var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"d-flex justify-content-center align-items-center text-uppercase text-muted my-3 py-3 border-top border-bottom"},[_vm._v("\n  Salto de página\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }